'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _objectPath = require('object-path');

var _objectPath2 = _interopRequireDefault(_objectPath);

var _shallowequal = require('shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _ExpandIcon = require('./ExpandIcon');

var _ExpandIcon2 = _interopRequireDefault(_ExpandIcon);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var TableCell = (0, _createReactClass2.default)({
  propTypes: {
    record: _propTypes2.default.object,
    prefixCls: _propTypes2.default.string,
    isColumnHaveExpandIcon: _propTypes2.default.bool,
    index: _propTypes2.default.number,
    expanded: _propTypes2.default.bool,
    expandable: _propTypes2.default.any,
    onExpand: _propTypes2.default.func,
    needIndentSpaced: _propTypes2.default.bool,
    indent: _propTypes2.default.number,
    indentSize: _propTypes2.default.number,
    column: _propTypes2.default.object
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
    return !(0, _shallowequal2.default)(nextProps, this.props);
  },
  isInvalidRenderCellText: function isInvalidRenderCellText(text) {
    return text && !_react2.default.isValidElement(text) && Object.prototype.toString.call(text) === '[object Object]';
  },
  render: function render() {
    var _props = this.props;
    var record = _props.record;
    var indentSize = _props.indentSize;
    var prefixCls = _props.prefixCls;
    var indent = _props.indent;
    var isColumnHaveExpandIcon = _props.isColumnHaveExpandIcon;
    var index = _props.index;
    var expandable = _props.expandable;
    var onExpand = _props.onExpand;
    var needIndentSpaced = _props.needIndentSpaced;
    var expanded = _props.expanded;
    var column = _props.column;
    var dataIndex = column.dataIndex;
    var render = column.render;
    var className = column.className;


    var text = _objectPath2.default.get(record, dataIndex);
    var tdProps = void 0;
    var colSpan = void 0;
    var rowSpan = void 0;

    if (render) {
      text = render(text, record, index);
      if (this.isInvalidRenderCellText(text)) {
        tdProps = text.props || {};
        rowSpan = tdProps.rowSpan;
        colSpan = tdProps.colSpan;
        text = text.children;
      }
    }

    // Fix https://github.com/ant-design/ant-design/issues/1202
    if (this.isInvalidRenderCellText(text)) {
      text = null;
    }
    /*** add by jiazhao 2017-02-09 添加rowSelection的render方法  ***/
    var expandIcon = _react2.default.createElement(_ExpandIcon2.default, {
      expandable: expandable,
      prefixCls: prefixCls,
      onExpand: onExpand,
      needIndentSpaced: needIndentSpaced,
      expanded: expanded,
      record: record
    });
    //第一列切没有dataIndex
    if (!dataIndex && indent == 0) {
      if (this.props.rowSelection && this.props.rowSelection.render) {
        var expandRender = this.props.rowSelection.render;
        expandIcon = expandRender(record, index, expandIcon);
        if (expandIcon && !_react2.default.isValidElement(expandIcon) && Object.prototype.toString.call(expandIcon) === '[object Object]') {
          tdProps = expandIcon.props || {};
          rowSpan = tdProps.rowSpan;
          colSpan = tdProps.colSpan;
          expandIcon = expandIcon.children;
        }
      }
    }
    /*** add end ***/

    var indentText = _react2.default.createElement('span', {
      style: { paddingLeft: indentSize * indent + 'px' },
      className: prefixCls + '-indent indent-level-' + indent
    });

    if (rowSpan === 0 || colSpan === 0) {
      return _react2.default.createElement('td', { style: { display: "none" } });
    }
    return _react2.default.createElement(
      'td',
      {
        colSpan: colSpan,
        rowSpan: rowSpan,
        className: className || ''
      },
      isColumnHaveExpandIcon ? indentText : null,
      isColumnHaveExpandIcon ? expandIcon : null,
      text
    );
  }
});

exports.default = TableCell;